var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("back-bar-drinks-section", {
    staticClass: "menu--section-two_column menu--section-back_bar_two_column",
    attrs: {
      menu: _vm.menu,
      section: _vm.section,
      "section-modifier": _vm.sectionModifier,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }